import { useDateTimeFormat } from '~/hooks';

export default function TimeEntryDetails({ timeEntry }) {
  const dateTimeFormat = useDateTimeFormat();
  return [
    dateTimeFormat.format(timeEntry.date),
    timeEntry.member?.name,
    timeEntry.project?.client?.name,
    timeEntry.project?.name,
    timeEntry.timeOffType?.name,
  ]
    .filter(Boolean)
    .join(' - ');
}
